export default __webpack_public_path__ + "maximize.ceb40121.svg";